{
  "title": "Pssst! An update is available!",
  "description": "Reload this page to use the latest version of Agenda Hero.",
  "reload": "Reload now"
}
